import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

/**
 * Line of the cart summary: marker dot, label and tag, details, notes and amount.
 * Projected slots: [lineLabel], [lineTag], [lineNote] (one element per note), default slot for details (one element per line).
 */
@Component({
  selector: 'app-cart-line',
  templateUrl: './cart-line.component.html',
  styleUrls: ['./cart-line.component.scss'],
  standalone: true,
  imports: [DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[style.--line-accent]': 'accent' }
})
export class CartLineComponent {
  // Marker dot and tag color: ticket type color (null: primary)
  @Input() accent: string | null = null;
  @Input() marker: boolean = true;
  @Input() amount: number | null = null;
  // Sign displayed before the amount ('-' credit, '+' fee)
  @Input() sign: string = '';
  // Unit price, detailed under the amount when quantity > 1
  @Input() quantity: number = 1;
  @Input() unitPrice: number | null = null;
  @Input() tone: 'default' | 'success' | 'primary' | 'medium' = 'default';
  // Result line (e.g. exchange difference): bolder label and larger amount
  @Input() emphasis: boolean = false;
}
